import { renderReactLegacy } from '@boozt/helper';
import type { AppProps } from '@boozt/types';
import React, { Suspense, useEffect, useState } from 'react';
import { FooterStandalone } from '@common/Footer/containers/Footer';

const MyLists = React.lazy(() => import(
    /* webpackChunkName: "MyLists" */
    '@boozt/app/components/organisms/my-lists/MyLists'
));

const Root = React.lazy(() => import(
    /* webpackChunkName: "Root" */
    '@boozt/app/components/molecules/root/Root'
));

export default function Footer(app: AppProps) {
    const [isClient, setIsClient] = useState(false);
    const { props, context } = app;
    const { footerStandalone } = props;

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <>
            {renderReactLegacy(FooterStandalone, context, footerStandalone)}
            {isClient && (
                <Suspense fallback={<div />}>
                    <MyLists {...app} />
                </Suspense>
            )}
            {isClient && (
                <Suspense fallback={<div />}>
                    <Root {...app} />
                </Suspense>
            )}
        </>
    );
}
